var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIos(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.58,
    d: "M24.5 0.5H0.5V24.5H24.5V0.5Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.6008 19.661C20.1908 18.761 20.4108 18.301 20.8608 17.291C17.5408 16.031 17.0108 11.301 20.2908 9.49097C19.2908 8.23097 17.8808 7.50098 16.5508 7.50098C15.5908 7.50098 14.9308 7.75098 14.3408 7.98098C13.8408 8.17098 13.3908 8.34097 12.8308 8.34097C12.2308 8.34097 11.7008 8.15097 11.1408 7.95097C10.5408 7.73097 9.90081 7.50098 9.10081 7.50098C7.61081 7.50098 6.02081 8.41098 5.01081 9.97098C3.59081 12.171 3.84081 16.291 6.13081 19.811C6.95081 21.071 8.05081 22.481 9.48081 22.501C10.0808 22.511 10.4708 22.331 10.9008 22.141C11.3908 21.921 11.9208 21.681 12.8508 21.681C13.7808 21.671 14.3008 21.921 14.7908 22.141C15.2108 22.331 15.5908 22.511 16.1808 22.501C17.6208 22.481 18.7808 20.921 19.6008 19.661Z",
    fill: "#04326B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.3395 2.5C16.4995 3.6 16.0495 4.69 15.4595 5.45C14.8295 6.27 13.7295 6.91 12.6695 6.87C12.4795 5.81 12.9695 4.72 13.5695 3.99C14.2395 3.19 15.3695 2.57 16.3395 2.5Z",
    fill: "#04326B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIos);
export default __webpack_public_path__ + "static/media/ios.28bd517fa9ac20fc8edd3b48853687fa.svg";
export { ForwardRef as ReactComponent };